import { Link } from "@tanstack/react-router";
import { X, Trash2 } from "lucide-react";
import { useInquiry } from "@/lib/inquiry-store";
import { fallbackImage } from "@/lib/catalog";

export function InquiryDrawer({
  open,
  onOpenChange,
}: {
  open: boolean;
  onOpenChange: (v: boolean) => void;
}) {
  const { items, remove } = useInquiry();
  return (
    <>
      <div
        onClick={() => onOpenChange(false)}
        className={`fixed inset-0 z-50 bg-ink/30 backdrop-blur-sm transition-opacity ${
          open ? "opacity-100" : "pointer-events-none opacity-0"
        }`}
      />
      <aside
        className={`fixed inset-y-0 right-0 z-50 flex h-dvh w-full max-w-md flex-col border-l border-border bg-background shadow-xl transition-transform duration-300 ${
          open ? "translate-x-0" : "translate-x-full"
        }`}
        inert={!open ? true : undefined}
      >
        <div className="flex items-center justify-between border-b border-border px-5 py-4">
          <h3 className="font-serif text-xl">Your Inquiry</h3>
          <button
            onClick={() => onOpenChange(false)}
            aria-label="Close"
            className="rounded-sm p-2 hover:bg-secondary"
          >
            <X className="h-4 w-4" />
          </button>
        </div>
        <div className="flex-1 overflow-y-auto px-5 py-4">
          {items.length === 0 ? (
            <p className="mt-12 text-center text-sm text-muted-foreground">
              Your inquiry list is empty. Browse the catalog and add products to request a wholesale
              quote.
            </p>
          ) : (
            <ul className="space-y-4">
              {items.map((it) => (
                <li key={it.productHandle} className="flex gap-3 border-b border-border pb-4">
                  <img
                    src={it.imageUrl || fallbackImage()}
                    alt=""
                    width={64}
                    height={64}
                    className="h-16 w-16 flex-shrink-0 rounded-sm object-cover"
                  />
                  <div className="flex-1">
                    <p className="font-serif text-base leading-tight">{it.productName}</p>
                    {it.categoryName && (
                      <p className="text-xs uppercase tracking-wider text-muted-foreground">
                        {it.categoryName}
                      </p>
                    )}
                    <p className="mt-1 text-sm">Qty: {it.quantity}</p>
                  </div>
                  <button
                    onClick={() => remove(it.productHandle)}
                    aria-label="Remove"
                    className="self-start rounded-sm p-1 text-muted-foreground hover:text-destructive"
                  >
                    <Trash2 className="h-4 w-4" />
                  </button>
                </li>
              ))}
            </ul>
          )}
        </div>
        {items.length > 0 && (
          <div className="border-t border-border px-5 py-4">
            <Link
              to="/inquiry"
              onClick={() => onOpenChange(false)}
              className="block w-full rounded-sm bg-primary px-4 py-3 text-center text-sm font-medium tracking-wide text-primary-foreground transition-colors hover:bg-primary/90"
            >
              Review & send inquiry
            </Link>
          </div>
        )}
      </aside>
    </>
  );
}
